export const SELECTOR
  = '[data-reka-calendar-cell-trigger]:not([data-outside-view]):not([data-outside-visible-view])'
export function getSelectableCells(calendar: HTMLElement): HTMLElement[] {
  return Array.from(calendar.querySelectorAll(SELECTOR)) ?? []
}
